import styled, { css } from 'styled-components';
import { Label } from '../label/index.js';
import { suppressProps } from '../../utils/index.js';
const getCheckboxCursorStyles = ({ loading, isReadOnly }) => {
    if (loading || isReadOnly)
        return css `
      &:not(:hover),
      &:hover {
        cursor: default;
      }
    `;
    return css ``;
};
const getCheckboxLabelDisabledStyles = ({ theme, isDisabled, }) => {
    if (!isDisabled)
        return css ``;
    return css `
    &:not(:hover),
    &:hover {
      opacity: ${theme.opacity.faded};
      cursor: not-allowed;
    }
  `;
};
function getCheckboxLabelStates({ isSelected, theme }) {
    return (isSelected &&
        css `
      color: ${theme.colors.controls[theme.styles.checkboxes.states.active.backgroundColor]};
    `);
}
export const CheckboxLabel = styled(Label)
    .withConfig(suppressProps('isSelected', 'disableInteractions', 'isDisabled', 'isReadOnly', 'loading'))
    .attrs({
    variant: 'paragraph',
})(({ theme, disableInteractions }) => css `
    display: flex;
    align-items: center;
    cursor: ${theme.styles.checkboxes.base.cursor};
    width: fit-content;
    pointer-events: ${disableInteractions && 'none'};
  `, getCheckboxLabelStates, getCheckboxCursorStyles, getCheckboxLabelDisabledStyles);
export const LabelText = styled(Label)
    .withConfig(suppressProps('isSelected', 'disableInteractions', 'isDisabled', 'isReadOnly'))
    .attrs({
    elementType: 'span',
    variant: 'paragraph',
})(() => css `
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  `);
function getCheckboxIconStates({ theme, isSelected, isHovered, }) {
    const { controls, borders } = theme.colors;
    const { states } = theme.styles.checkboxes;
    if (isSelected)
        return css `
      border-color: ${borders[states.active.borderColor]};
      background-color: ${controls[states.active.backgroundColor]};
    `;
    if (isHovered)
        return css `
      border-color: ${borders[states.hover.borderColor]};
      background-color: ${controls[states.hover.backgroundColor]};
    `;
    return css `
    border-color: ${borders[states.inactive.borderColor]};
    background-color: ${controls[states.inactive.backgroundColor]};
  `;
}
function getIconBox({ theme }) {
    const { icon } = theme.styles.checkboxes;
    return css `
    width: ${theme.sizes.x4};
    height: ${theme.sizes.x4};
    border-style: solid;
    border-width: ${icon.borderWidth};
    border-radius: ${icon.borderRadius};
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;
}
export const IconContainer = styled.i.withConfig(suppressProps('isSelected', 'isFocusVisible', 'isHovered'))(({ theme, isFocusVisible }) => css `
    line-height: ${theme.lineHeights.none};
    margin-right: ${theme.space.x2};
    outline: ${isFocusVisible
    ? theme.outlines.control.rule
    : theme.outlines.none};
    outline-offset: ${theme.outlines.control.offset};
  `, getIconBox, getCheckboxIconStates);
//# sourceMappingURL=checkbox.styles.js.map